import { useCallback, useRef } from "react";

/**
 * A function with one identity for the component's lifetime that calls the latest `callback` rendered.
 *
 * For a handler handed to something that re-renders when a prop's identity changes (a memoized table row) while the
 * handler closes over state that changes far more often than what it is handed to. Call it from events, not during
 * render.
 */
export function useLatestCallback<Args extends unknown[], Result>(
  callback: (...args: Args) => Result,
): (...args: Args) => Result {
  const ref = useRef(callback);
  ref.current = callback;
  return useCallback((...args: Args) => ref.current(...args), []);
}
